import { FunctionComponent } from 'react';
import { SchoolPageTabContentOverview } from '../../components/SchoolPageTabContentOverview/SchoolPageTabContentOverview';
import { SchoolPageTabContentPropertiesForSaleOrRent } from '../../components/SchoolPageTabContentPropertiesForSaleOrRent/SchoolPageTabContentPropertiesForSaleOrRent';

interface SchoolPageTabContentContainerProps {
  childPath?: string;
}

export const SchoolPageTabContentContainer: FunctionComponent<
  SchoolPageTabContentContainerProps
> = ({ childPath }) =>
  childPath && (childPath === 'properties-for-sale' || childPath === 'properties-for-rent') ? (
    <SchoolPageTabContentPropertiesForSaleOrRent />
  ) : (
    <SchoolPageTabContentOverview />
  );
